/**
 * Request Timeout Handler
 * This script helps manage request timeouts for AJAX requests in the Shopify theme
 */
class RequestTimeoutHandler {
  constructor() {
    // Listen for all fetch requests that might need monitoring
    this.setupFetchMonitoring();
    this.initAutoResetLoadingStates();
  }

  setupFetchMonitoring() {
    // Store the original fetch function
    const originalFetch = window.fetch;
    
    // Replace with our enhanced version
    window.fetch = function(...args) {
      // Create a timeout for the fetch request
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Request timeout - the server took too long to respond'));
        }, 30000); // 30-second timeout
      });
      
      // Race between the original fetch and the timeout
      return Promise.race([
        originalFetch.apply(this, args),
        timeoutPromise
      ]).catch(error => {
        console.error('Fetch error:', error);
        // Reset any loading states if needed
        RequestTimeoutHandler.resetLoadingStates();
        throw error;
      });
    };
  }

  initAutoResetLoadingStates() {
    // Reset any hanging loading states after 45 seconds
    // This is a safety measure in case the error handling misses something
    setInterval(() => {
      const loadingElements = document.querySelectorAll('.loading, .loading__spinner:not(.hidden)');
      const currentTime = new Date().getTime();
      
      loadingElements.forEach(element => {
        if (!element.dataset.loadingStartTime) {
          element.dataset.loadingStartTime = currentTime;
        } else {
          // If loading state has been active for more than 45 seconds
          const loadingTime = currentTime - parseInt(element.dataset.loadingStartTime);
          if (loadingTime > 45000) {
            // Reset the loading state
            if (element.classList.contains('loading__spinner')) {
              element.classList.add('hidden');
            } else {
              element.classList.remove('loading');
            }
            delete element.dataset.loadingStartTime;
          }
        }
      });
    }, 10000); // Check every 10 seconds
  }

  static resetLoadingStates() {
    // Reset all loading states in case of an error
    const loadingSpinners = document.querySelectorAll('.loading__spinner:not(.hidden)');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    
    document.querySelectorAll('.loading').forEach((element) => {
      element.classList.remove('loading');
    });
  }
}

// Initialize the timeout handler when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  window.requestTimeoutHandler = new RequestTimeoutHandler();
});